var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "loading",
      staticStyle: { margin: "auto", display: "block" },
      attrs: {
        width: "50px",
        height: "50px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid"
      }
    },
    [
      _c("rect", {
        staticClass: "bk",
        attrs: { x: "0", y: "0", width: "100", height: "100", fill: "none" }
      }),
      _c("circle", {
        attrs: {
          cx: "50",
          cy: "50",
          r: "40",
          stroke: _vm.background,
          fill: "none",
          "stroke-width": "10",
          "stroke-linecap": "round"
        }
      }),
      _c(
        "circle",
        {
          attrs: {
            cx: "50",
            cy: "50",
            r: "40",
            stroke: _vm.foreground,
            fill: "none",
            "stroke-width": "6",
            "stroke-linecap": "round"
          }
        },
        [
          _c("animate", {
            attrs: {
              attributeName: "stroke-dashoffset",
              dur: "2s",
              repeatCount: "indefinite",
              from: "0",
              to: "502"
            }
          }),
          _c("animate", {
            attrs: {
              attributeName: "stroke-dasharray",
              dur: "2s",
              repeatCount: "indefinite",
              values: "150.6 100.4;1 250;150.6 100.4"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-baedc280", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baedc280","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/loading.vue
// module id = 165
// module chunks = 4